/**
 * Logo Component
 *
 * Displays the DramaDetector logo (dd-icon.png)
 * Used in tab screen headers for brand consistency
 *
 * Features:
 * - Responsive sizing (adjusts for mobile/tablet/desktop)
 * - Accessibility label
 * - Optimized image loading with React Native Image
 */
import { Image, View, type ImageStyle, type ViewStyle } from 'react-native';

interface LogoProps {
  /** Size variant: sm (32px), md (48px), lg (64px). Default: md */
  size?: 'sm' | 'md' | 'lg';
  /** Additional container styles */
  style?: ViewStyle;
}

const SIZE_MAP = {
  sm: 32,
  md: 48,
  lg: 64,
} as const;

export function Logo({ size = 'md', style }: LogoProps) {
  const dimension = SIZE_MAP[size];

  const imageStyle: ImageStyle = {
    width: dimension,
    height: dimension,
    resizeMode: 'contain',
  };

  return (
    <View style={style}>
      <Image
        source={require('../assets/images/logo.png')}
        style={imageStyle}
        accessibilityLabel="DramaDetector logo"
        accessibilityRole="image"
      />
    </View>
  );
}
